import { render, staticRenderFns } from "./AccrualsRulesEmptyState.vue?vue&type=template&id=acdffca8&scoped=true"
import script from "./AccrualsRulesEmptyState.vue?vue&type=script&lang=js"
export * from "./AccrualsRulesEmptyState.vue?vue&type=script&lang=js"
import style0 from "./AccrualsRulesEmptyState.vue?vue&type=style&index=0&id=acdffca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acdffca8",
  null
  
)

export default component.exports